// @ts-check
import * as React from 'react';

import { useDispatch, useSelector } from 'react-redux';

import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import { makeStyles } from '@material-ui/core/styles';

import { useEffect } from 'react';
import { LoadingComponent } from '../components/loading-component';
import { UsersListComponent } from '../components/user-list-component';
import { getUsersAction } from '../redux/actions/user-actions';
import { FloatingActionButtonSize } from '../components/add-component';
import { BackNavigationComponent } from '../../../../core/routes/components/back-navigation-component';

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  }
}));

export default function UsersPage() {
  const classes = useStyles();

  const { users, loading } = useSelector((state) => state.users);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getUsersAction());
  }, [dispatch]);

  return (
    <>
      <React.Fragment>
        <CssBaseline />
        <Container className={classes.container}>
          {loading && <LoadingComponent />}
          {!loading && (
            <>
              <BackNavigationComponent page="Users" uri="/" />
              <UsersListComponent users={users} />
              <FloatingActionButtonSize />
            </>
          )}
        </Container>
      </React.Fragment>
    </>
  );
}
